query AudienceEstimate(
  $audience: AudienceFilterInput
  $contactListIds: [ID!]!
) {
  audienceEstimate(audience: $audience, contactListIds: $contactListIds) {
    viewers
    contacts
  }
}
